/**
 * Dev Mail - Read Command
 * Display full content of a specific email
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface ReadOptions {
    json?: boolean;
}

function htmlToText(html: string[]): string {
    return html
        .join('\n')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

async function handleRead(address: string, messageId: string, options: ReadOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    const api = new TempMailApiService(config);
    const result = await api.getMessage(address, messageId);

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    const msg = result.data!;

    if (options.json) {
        console.log(JSON.stringify({ success: true, data: msg }));
        return;
    }

    const body = msg.text || (msg.html?.length ? htmlToText(msg.html) : '(no content)');

    console.log(chalk.bold.cyan('📧 Email Detail\n'));
    console.log(`  ${chalk.bold('From:')}    ${msg.from.name} <${msg.from.address}>`);
    console.log(`  ${chalk.bold('To:')}      ${msg.to.map((t) => t.address).join(', ')}`);
    if (msg.cc?.length) console.log(`  ${chalk.bold('CC:')}      ${msg.cc.join(', ')}`);
    console.log(`  ${chalk.bold('Subject:')} ${msg.subject || '(no subject)'}`);
    console.log(`  ${chalk.bold('Date:')}    ${new Date(msg.createdAt).toLocaleString('vi-VN')}`);
    if (msg.hasAttachments) console.log(`  ${chalk.yellow('📎 Has attachments')}`);
    console.log('\n' + '─'.repeat(80) + '\n');
    console.log(body);
    console.log('\n' + '─'.repeat(80));
}

export function createMailReadCommand(): Command {
    return new Command('read')
        .description('Đọc nội dung đầy đủ của một email')
        .argument('<address>', 'Địa chỉ email')
        .argument('<message-id>', 'ID của email (từ lệnh inbox)')
        .option('-j, --json', 'Output dạng JSON (raw)')
        .addHelpText('after', `
Examples:
  $ j dev mail read user@dollicons.com abc123
  $ j dev mail read user@dollicons.com abc123 -j
`)
        .action(async (address: string, messageId: string, options: ReadOptions) => {
            await handleRead(address, messageId, options);
        });
}
